import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from "./components/Header";
import FranquiciasMagnificos from './pages/FranquiciasMagnificos';
import './App.css';

const App: React.FC = () => {
  return (
    <>
      <Header />
      <div className="App">
        <Routes>
          <Route path="/" element={<FranquiciasMagnificos />} />
        </Routes>
      </div>
    </>
  );
}

export default App;